import { useEffect, useState } from "react";

import useData from "../../hooks/useData";
import useBrowser from "../../hooks/useBrowser";
import usePage from "../../hooks/usePage";

import Modal from "./Modal";

import SurveyEntry from "../ui/SurveyEntry";
import Dialog_YesNo from "../ui/Dialog_YesNo";
import OrderEntry from "../ui/OrderEntry";
import Loading from "../ui/Loading";
import { Box } from "@mui/material";

const sizes = {
  mobile: {
    width: 360,
    height: 740,
  },
};

const SurveyEntryModal = ({
  surveyId,
  callId,
  mode,
  open,
  onClose,
  layout = "mobile",
  onRefresh,
  isDisabled,
}) => {
  const { getFromServer } = useData();
  const { windowHeight } = useBrowser();
  const { showMessage } = usePage();

  const [survey, setSurvey] = useState(null);
  const [project, setProject] = useState(null);
  const [changesMade, setChangesMade] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [surveyStatus, setSurveyStatus] = useState("incomplete");
  const [updatedCallData, setUpdatedCallData] = useState(null);

  useEffect(() => {
    getData();
  }, [surveyId]);

  const getData = async () => {
    const surveyData = await getFromServer({
      entityName: "Survey",
      id: surveyId,
    });

    if (surveyData) {
      setSurvey(surveyData);
      const projectData = await getFromServer({
        entityName: "Project",
        id: surveyData.projectId,
      });
      setProject(projectData);
    }
  };

  const handleChange = () => {
    setChangesMade(true);
    setSaved(false);
  };
  const handleSave = (status, updatedCallData) => {
    setSurveyStatus(status);
    setSaved(true);
    // Store updated call data to pass back on close
    if (updatedCallData) {
      setUpdatedCallData(updatedCallData);
    }
    // setChangesMade(false);
  };

  const handleClose = (event, reason) => {
    if (event?.preventDefault) event.preventDefault();
    if (event?.stopPropagation) event.stopPropagation();

    // Prevent nested modal backdrop/escape events from closing parent CallDocket modal.
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    // if (!changesMade || saved) {
    //   onClose(changesMade, surveyStatus);
    //   return;
    // }

    setShowDialog(false);
    onClose(changesMade, surveyStatus, updatedCallData);
  };

  const handleYes = () => {
    setShowDialog(false);
    onClose(changesMade);
  };

  const handleNo = () => {
    setShowDialog(false);
  };

  if (!survey) return <Loading />;

  return (
    <>
      <Modal
        title={survey?.name}
        subTitle={project?.name}
        entity="aa"
        open={open}
        onClose={handleClose}
        width={`${sizes[layout].width}px`}
        height={`${
          sizes[layout].height > windowHeight
            ? windowHeight
            : sizes[layout].height
        }px`}
      >
        <Box>
          {survey.surveyType === "survey" && (
            <SurveyEntry
              survey={survey}
              project={project}
              mode={mode}
              callId={callId}
              onRefresh={onRefresh}
              onChange={handleChange}
              onSave={handleSave}
              isDisabled={isDisabled}
            />
          )}
          {survey.surveyType === "order" && (
            <OrderEntry
              surveyId={survey.id}
              callId={callId}
              mode={mode}
              onClose={onClose}
            />
          )}
        </Box>
      </Modal>

      {showDialog && (
        <Dialog_YesNo
          open={showDialog}
          onClose={() => setShowDialog(false)}
          title="Changes Made"
          message="Do you wish to loose any changes made?"
          onYes={handleYes}
          onNo={handleNo}
        />
      )}
    </>
  );
};

export default SurveyEntryModal;
